import React from 'react';
import ReactDOM from 'react-dom/client';
import '@travel/design-tokens/tokens.css';

import { App } from './app';
import './styles.css';
import './erp-layout.css';
import './erp-reference-theme.css';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
